import React, { useEffect } from 'react';
import NotificationSystem from 'react-notification-system';
import {getErrorMessage} from '../../services/errors';


const Notification = ({error, type, message}) => {
    let notificationSystem = React.createRef();
    useEffect(() => {
        addNotification()
    })
    const addNotification = event => {
        let notification = notificationSystem.current;
        notification.addNotification({
          message: type === 'error' ?  getErrorMessage(error) : message,
          level: type === 'error' ? 'error' : 'success'
        });
      };

    return (
        <NotificationSystem ref={notificationSystem}/>
    );
}
export default Notification